export default __webpack_public_path__ + "static/media/test-image.6e7465fe.png";